<script>
import store from '@state/store'
import { debounce } from 'debounce'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import AdminTable from '@components/admin-table.vue'
import { USERS_TABLE_FIELDS } from '@adminCompanies/constant'
import Table from '@adminUsers/components/event-admin-table.vue'
import AddEventAdmins from '@adminCompanies/components/add-event-admins.vue'

export default {
  components: {
    Layout,
    AdminTable,
    Table,
    AddEventAdmins,
  },
  data() {
    return {
      tableFieldsAdmin: USERS_TABLE_FIELDS,
    }
  },
  computed: {
    ...authComputed,
    companyId() {
      return this.$route.params.companyId
    },
    page() {
      return this.$store.state.adminUsers.page
    },
    perPage() {
      return this.$store.state.adminUsers.perPage
    },
    listsAdmin() {
      return this.$store.state.adminUsers.lists || []
    },
    totalAdmin() {
      return this.$store.state.adminUsers.total
    },
    loaded() {
      return this.$store.state.adminUsers.loaded
    },
    hasNoData() {
      return !this.lists.length && this.loaded
    },
    loading() {
      return !this.lists.length && !this.loaded
    },
  },
  methods: {
    setPage(params) {
      store.dispatch('adminUsers/setPage', params)
    },
    setFilterParams: debounce(async function setFilterParams(params) {
      await store.dispatch('adminUsers/setFilterParams', params)
    }, 500),
    setSortParams(params) {
      store.dispatch('adminUsers/setSortParams', params)
    },
    goAddItem(item) {
      this.$router.push({
        name: 'adminUsersAdd',
        params: { companyId: this.companyId },
      })
    },
    refreshEventAdminsTable() {
      this.$refs.eventAdminsTable.fetchData()
    },
    goEditItem(item) {
      this.$router.push({
        name: 'adminUsersEdit',
        params: { companyId: this.companyId, userId: item.id, item },
      })
    },
    deleteItem(userId) {
      store.dispatch('adminUsers/removeUser', {
        companyId: this.companyId,
        userId,
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white pt-4 px-8 pb-12 mb-16">
      <AdminTable
        table-type="USERS"
        :table-fields="tableFieldsAdmin"
        :total-num="totalAdmin"
        :list-data="listsAdmin"
        :data-loaded="loaded"
        :cur-page="page"
        :per-page="perPage"
        @table-add-item="goAddItem"
        @table-set-sort-params="setSortParams"
        @table-set-filter-params="setFilterParams"
        @table-go-edit-item="goEditItem"
        @table-delete-item="deleteItem"
        @table-set-page="setPage"
      />
    </div>
    <div class="bg-white pt-4 px-8 pb-12 mb-16">
      <Table
        ref="eventAdminsTable"
        :company-id="companyId"
        :no-new-btn="true"
        :no-edit-btn="true"
        table-type="EVENT_ADMINS"
      />
      <AddEventAdmins
        :company-id="companyId"
        @refresh-event-admins-table="refreshEventAdminsTable"
      />
    </div>
  </Layout>
</template>
